import { render, staticRenderFns } from "./SettingsLeadScore.vue?vue&type=template&id=a6b51392&scoped=true"
import script from "./SettingsLeadScore.vue?vue&type=script&lang=js"
export * from "./SettingsLeadScore.vue?vue&type=script&lang=js"
import style0 from "./SettingsLeadScore.vue?vue&type=style&index=0&id=a6b51392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b51392",
  null
  
)

export default component.exports